// import * as React from "react";

// import { cn } from "@/lib/utils";

// const Textarea = React.forwardRef<
// 	HTMLTextAreaElement,
// 	React.ComponentProps<"textarea">
// >(({ className, ...props }, ref) => {
// 	return (
// 		<textarea
// 			className={cn(
// 				"flex min-h-[80px]  w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
// 				className,
// 			)}
// 			ref={ref}
// 			{...props}
// 		/>
// 	);
// });
// Textarea.displayName = "Textarea";

// export { Textarea };

import * as React from "react";
import { cn } from "@/lib/utils";

const Textarea = React.forwardRef<
	HTMLTextAreaElement,
	React.ComponentProps<"textarea"> & { autoResize?: boolean }
>(({ className, autoResize = false, ...props }, ref) => {
	const textareaRef = React.useRef<HTMLTextAreaElement>(null);

	// Combine refs
	const combinedRef = React.useCallback(
		(node: HTMLTextAreaElement) => {
			textareaRef.current = node;
			if (typeof ref === "function") {
				ref(node);
			} else if (ref) {
				ref.current = node;
			}
		},
		[ref],
	);

	const adjustHeight = React.useCallback(() => {
		const textarea = textareaRef.current;
		if (textarea && autoResize) {
			textarea.style.height = "auto";
			textarea.style.height = `${textarea.scrollHeight}px`;
		}
	}, [autoResize]);

	React.useEffect(() => {
		adjustHeight();
	}, [props.value, adjustHeight]);

	const handleInput = (e: React.FormEvent<HTMLTextAreaElement>) => {
		adjustHeight();
		if (props.onInput) {
			props.onInput(e);
		}
	};

	return (
		<textarea
			className={cn(
				"flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
				autoResize && "resize-none overflow-hidden",
				className,
			)}
			ref={combinedRef}
			onInput={handleInput}
			{...props}
		/>
	);
});
Textarea.displayName = "Textarea";

export { Textarea };
